import React from 'react';
import type { HexColor } from 'src/types/colors';
import styles from './index.module.scss';

export type Props = {
  fillColor?: HexColor;
  className?: string;
  direction?: 'right' | 'left' | 'top' | 'bottom';
};

export const ArrowIcon: React.FC<Props> = ({ fillColor = '#1E2127', className, direction = 'right' }) => {
  const directionClass = styles[direction] || styles.right;
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${directionClass}`}
    >
      <g clipPath="url(#clip0_4907_47653)">
        <path d="M1.58594 2L6.58594 7" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
        <path d="M1.58594 12L6.58594 7" stroke={fillColor} strokeWidth="2" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_4907_47653">
          <rect width="12.828" height="7.828" fill="white" transform="translate(8 0.58606) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};
